import { colors } from "styles/colors";

type Props = {
  className?: string;
};

export const DrugIcon: React.FC<Props> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68795 8.06691L5.96282 5.12521L9.23767 2.18351C11.2367 0.387842 14.217 0.666973 15.8944 2.80697C17.5719 4.94697 17.3111 8.13744 15.312 9.93309L12.0372 12.8748L8.76233 15.8165C6.76329 17.6122 3.78296 17.333 2.10556 15.193C0.428163 13.053 0.688909 9.86257 2.68795 8.06691Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
      />
      <path
        d="M6.86719 7.93335L9.53385 11.1333"
        stroke={colors.pink500}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
